import axios from "axios";
import { createMessage, createGenericErrorAlert } from "./messages";
import { tokenConfig } from "./auth";

import {
    GET_QUOTES,
    GET_QUOTE,
    CREATE_QUOTE,
    EDIT_QUOTE,
    SEND_QUOTE,
    RESPOND_TO_QUOTE,
    CONVERT_QUOTE,
    DELETE_QUOTE,
    CLEAR_QUOTE,
} from "./types";

// GET ALL QUOTES (sent or received)
export const getQuotes = () => (dispatch, getState) => {
    axios
        .get(`/v0/api/contract/quote/`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }));
            } else {
                dispatch({
                    type: GET_QUOTES,
                    payload: res.data,
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({ ...err.response.data, ...err.response.status })));
};

// GET ONE QUOTE
export const getQuote = (uuid) => (dispatch, getState) => {
    axios
        .get(`/v0/api/contract/quote/${uuid}/`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }));
            } else {
                dispatch({
                    type: GET_QUOTE,
                    payload: res.data,
                });
            }
        })
        .catch((err) => dispatch(createGenericErrorAlert({ ...err.response.data, ...err.response.status })));
};

// CREATE A DRAFT QUOTE
export const createQuote = (quote) => (dispatch, getState) => {
    return axios
        .post(`/v0/api/contract/quote/`, quote, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }));
            } else {
                dispatch({
                    type: CREATE_QUOTE,
                    payload: res.data,
                });
            }
            return res;
        })
        .catch((err) => dispatch(createGenericErrorAlert({ ...err.response.data, ...err.response.status })));
};

// EDIT A DRAFT QUOTE'S PLAIN FIELDS
export const editQuote = (uuid, quote) => (dispatch, getState) => {
    return axios
        .put(`/v0/api/contract/quote/${uuid}/`, quote, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }));
            } else {
                dispatch({
                    type: EDIT_QUOTE,
                    payload: res.data,
                });
            }
            return res;
        })
        .catch((err) => dispatch(createGenericErrorAlert({ ...err.response.data, ...err.response.status })));
};

// SEND A DRAFT QUOTE
export const sendQuote = (uuid, recipientEmail) => (dispatch, getState) => {
    return axios
        .post(`/v0/api/contract/quote/${uuid}/send/`, { fk_email_recipient: recipientEmail }, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }));
            } else {
                dispatch({
                    type: SEND_QUOTE,
                    payload: res.data,
                });
                dispatch(createMessage({ success: "Quote sent" }));
            }
            return res;
        })
        .catch((err) => dispatch(createGenericErrorAlert({ ...err.response.data, ...err.response.status })));
};

// ACCEPT / DECLINE / REQUEST REVISION / ACCEPT-AND-CONVERT ON A PENDING QUOTE
export const respondToQuote = (uuid, response, revisionReason) => (dispatch, getState) => {
    const body = { response };
    if (revisionReason) body.revision_reason = revisionReason;

    return axios
        .post(`/v0/api/contract/quote/${uuid}/respond/`, body, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }));
            } else if (response === "AcceptAndConvert") {
                //GitHub #663 -- this response is Contract-shaped (contract_id, not quote_id), not
                //Quote-shaped, since the Quote converted immediately. Skip RESPOND_TO_QUOTE
                //entirely rather than corrupt state.quote with mismatched keys -- the component
                //navigates straight to the new Contract's own page instead.
                dispatch(createMessage({ success: "Quote accepted and converted to Contract" }));
            } else {
                dispatch({
                    type: RESPOND_TO_QUOTE,
                    payload: res.data,
                });
                const responseMessages = { Accept: "accepted", Decline: "declined", RequestRevision: "revision requested" };
                dispatch(createMessage({ success: `Quote ${responseMessages[response] || "updated"}` }));
            }
            return res;
        })
        .catch((err) => dispatch(createGenericErrorAlert({ ...err.response.data, ...err.response.status })));
};

// CONVERT AN ACCEPTED QUOTE (Basic tier -> Contract; Enterprise currently returns a stub error)
export const convertQuote = (uuid, pid) => (dispatch, getState) => {
    return axios
        .post(`/v0/api/contract/quote/${uuid}/convert/`, { pid }, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }));
            } else {
                dispatch({
                    type: CONVERT_QUOTE,
                    payload: res.data,
                });
            }
            return res;
        })
        .catch((err) => dispatch(createGenericErrorAlert({ ...err.response.data, ...err.response.status })));
};

// DELETE A DRAFT QUOTE
export const deleteQuote = (uuid) => (dispatch, getState) => {
    return axios
        .delete(`/v0/api/contract/quote/${uuid}/`, tokenConfig(getState))
        .then((res) => {
            if (res.data.error) {
                dispatch(createMessage({ error: res.data.error }));
            } else {
                dispatch(createMessage({ success: "Quote deleted" }));
                dispatch({
                    type: DELETE_QUOTE,
                    payload: uuid,
                });
            }
            return res;
        })
        .catch((err) => dispatch(createGenericErrorAlert({ ...err.response.data, ...err.response.status })));
};

// CLEAR THE CURRENTLY-VIEWED QUOTE
export const clearQuote = () => (dispatch) => {
    dispatch({
        type: CLEAR_QUOTE,
        payload: null,
    });
};
